import axios from '@/http/axios/index.js'

export default {
    list: function (data) {
        return axios.get('repse/documents', { params: data })
    },
    store: function (data) {
        return axios.post('repse/documents', data)
    },
    update: function (id, data) {
        return axios.put('repse/documents/' + id, data)
    },
    getFrequencies: function (data) {
        return axios.get('repse/getFrequencies', data)
    },
}